import styled from "styled-components";
import { COLORS } from "../../assets/utils/enums/colors";
import { MediumText } from "../typography";
import breakpoints from "../../assets/styles/breakpoint";
import arrow from "../../assets/images/icons/checkbox-arrow-icon.svg";

const Checkbox: React.FC<{
  state: boolean;
  setState: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ state, setState }) => {
  return <CheckboxStyle type="checkbox" checked={state} readOnly />;
};

export default Checkbox;
interface CheckboxInputProps {
  text: string;
  state: boolean;
  setState: React.Dispatch<React.SetStateAction<boolean>>;
}

export const CheckboxInput: React.FC<CheckboxInputProps> = ({
  text,
  state,
  setState,
}) => {
  return (
    <CheckboxSpan
      className="d-flex align-items-center gap-2"
      onClick={() => setState((prev) => !prev)}
    >
      <Checkbox state={state} setState={setState} />
      <MediumText>{text}</MediumText>
    </CheckboxSpan>
  );
};

const CheckboxSpan = styled.span`
  cursor: pointer;
  color: ${COLORS.secondary1};

  ${MediumText} {
  color: ${COLORS.secondary1};
  }
`;

const CheckboxStyle = styled.input`
  -webkit-appearance: none;
  appearance: none;
  width: 24px;
  height: 24px;
  border: 1px solid ${COLORS.secondary1};
  outline: none;
  cursor: pointer;
  position: relative;
  border-radius: 8px;
  border-color: #737b8b;

  &:checked::before {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 19px;
    height: 19px;
    background-color: ${COLORS.blue};
    content: "";
    background-repeat: no-repeat;
    background-position: center;
    background-size: 11px;
    background-image: url(${arrow});
    text-align: center;
    transition: backgroundColor 300ms ease;
    border-radius: 6px;
  }

  ${breakpoints.md} {
    width: 20px;
    height: 20px;

    &:checked::before {
      width: 14px;
      height: 14px;
    }
  }
`;
